import styled from 'styled-components'

export const TopLabel = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 400; /* Medium */
  line-height: 1;
  color: #868686;
`

export const ValueLabel = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 400; /* Regular */
  line-height: 16px;
  color: #000000;
  width: 101px;
  height: 16px;
  display: inline-block;
  margin-top: 3px;
`
